import React,{useEffect,useState} from 'react';
import firebase from './firebase'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
 } from "react-router-dom";
 import {useSelector,useDispatch} from 'react-redux'
 import Landing from './components/landing/landing'
import Dashboard from './components/dashboard'
import {notification,message} from 'antd'
import Spinner from './components/common/Spinner'

function App() {
  const [loading,setLoading] = useState(false)
  const auth = useSelector(state=>state.auth)
  const dispatch = useDispatch()
  useEffect(()=>{
    setLoading(true)
    firebase.auth().onAuthStateChanged(function(user) {
        setLoading(false)
        if (user) {
            dispatch({type:"REQUEST_AUTH_SUCCESS",payload:user.providerData[0]})
        } else {
            dispatch({type:"AUTH_FAILED"}) 
            dispatch({type:"RESET_USER"}) 
            notification.info({
              message: 'Hi Buddy',
              description:
                'Click on Get Started and start earning money',
                
              onClick: () => {
                
                notification.destroy()
              },
              placement:"bottomLeft"
            });
        }
      });
    },[]);
  return (
    
    <div className="App">
      <Router>
        {auth.isAuth ?  <span>
            <Redirect to="/dashboard"/>
          </span>:<Redirect to="/"/>}
       
        <Switch>
          <Route path="/" exact>
          {loading?<Spinner/>:<Landing/>}
            
          </Route>
         
          <Route path="/dashboard">
            <Dashboard/>
          </Route>
          
        </Switch>
        </Router>
      
     
    </div>
  );
}

export default App;
